// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/passenger-weight-estimation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/passenger-weight-estimation/passenger-weight-estimation.js';

mount([g0]);
